import script from "./LogDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LogDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./LogDetailDialog.vue?vue&type=style&index=0&id=8c7e1cca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c7e1cca"]])

export default __exports__